import type { CustomDataMap, CustomDataType } from 'owa-analytics-types';

// Precompiled regex for WF_Custom1..WF_Custom15
const wfCustomRangeRe = /^WF_Custom(1[0-5]|[1-9])$/;

export function getUnifiedPerfCustomWaterfall(
    datapointCustomDataMap: CustomDataMap
): Partial<Record<string, CustomDataType>> {
    // Collect only WF_Custom1..WF_Custom15 entries
    const perfCustomWaterfall: CustomDataMap = {};

    for (const [key, val] of Object.entries(datapointCustomDataMap)) {
        if (wfCustomRangeRe.test(key)) {
            perfCustomWaterfall[key] = val as CustomDataType;
        }
    }

    return perfCustomWaterfall;
}
